import { Assessment } from './components/assessment';
import BigNumbers from './components/BigNumbers';
import CareMatrix from './components/CareMatrix';
import { Criticality } from './components/criticality';
import { MoodTracker } from './components/mood-tracker';

import * as S from './styles';

export function Summary() {
  return (
    <S.Wrapper>
      <BigNumbers />
      <Criticality />
      <Assessment />
      <MoodTracker />
      <CareMatrix />
    </S.Wrapper>
  );
}
